module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-layout', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Uygulama Paylaşımları")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav-active-border b-primary top box"
  }, [_c('div', {
    staticClass: "nav nav-md"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/dashboards/appshare/countries',
        query: {
          id: _vm.dashboardId
        }
      },
      "active-class": "active"
    }
  }, [_c('span', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Ülkeler")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        path: '/dashboards/appshare/country',
        query: {
          id: _vm.dashboardId
        }
      },
      "active-class": "active"
    }
  }, [_c('span', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" Ülke Detay")])], 1)]), _vm._v(" "), _c('router-view')], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-710f2fc1!./~/vue-loader/lib/selector.js?type=template&index=0!./public/src/pages/dashboard/appshare.vue
// module id = 381
// module chunks = 0